import React from 'react';
import Select from 'react-select';

import CriterionApi from '../../api/criterion';
import Message from '../form/Message';
import AuthService from '../../state/auth.service';
import Button from '../form/Button';

const WORKING_STATES = ['Not Started', 'Started', 'Revision Required'];

class StatusCard extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            statusOptions: [],
            currentStatus: null,
            message: null,
        };

        this.updateStatus = this.updateStatus.bind(this);
    }

    componentDidMount() {
        // Set the status options
        CriterionApi.getStatuses().then(statuses => {
            let opts = statuses.map(status => {
                return { value: status, label: status };
            });
            this.setState({
                statusOptions: opts,
            });
        });
    }

    componentWillReceiveProps(nextProps) {
        // User should not be able to select 'Prevalidated' from this screen
        if (nextProps.criterion.status !== 'Prevalidated') {
            let statuses = this.state.statusOptions.filter(
                e => e.value !== 'Prevalidated'
            );
            this.setState({
                statusOptions: statuses,
            });
        }
    }

    updateStatus(newStatus) {
        if (typeof this.props.onCriterionChange === 'function') {
            let theChange = { status: newStatus };
            if (newStatus === 'Prevalidated') {
                theChange.checkin = '1';
            }
            this.props.onCriterionChange(theChange);
        } else {
            CriterionApi.updateStatus(this.props.criterion.id, newStatus)
                .then(result => {
                    this.setState({
                        currentStatus: newStatus,
                    });
                })
                .catch(error => {
                    this.setState({
                        message: 'Unable to change criterion status.',
                    });
                });
        }
    }

    render() {
        const criterion = this.props.criterion;
        let status = criterion.status;
        if (this.state.currentStatus) {
            status = this.state.currentStatus;
        }

        const adminSelect = (
            <Select
                name="status"
                options={this.state.statusOptions}
                disabled={criterion.status === 'Prevalidated' || this.props.disableCriterion}
                value={status}
                onChange={selection => {
                    this.updateStatus(selection.value);
                }}
                clearable={false}
                searchable={false}
            />
        );

        const reviewButton = (
            <Button
                type="button"
                defaultText="Ready for Review"
                onClick={e => this.updateStatus('Review Ready')}
            />
        );

        const readOnlyStatus = <div className="statusText">{status}</div>;

        const user = AuthService.getUser();
        let statusContent = readOnlyStatus;
        if (user && !this.props.disableCriterion) {
            if (user.role === 'Administrator' || user.role === 'Restricted') {
                statusContent = adminSelect;
            } else if (user.role === 'Document Provider') {
                if (WORKING_STATES.indexOf(status) >= 0) {
                    // show the button
                    statusContent = reviewButton;
                }
                // else leave it as read only status
            }
        }

        return (
            <div className="StatusCard">
                {statusContent}
                <Message error={this.state.message} />
            </div>
        );
    }
}

export default StatusCard;
